import { Injectable } from "@angular/core";
import { MatDialog } from "@angular/material";

import { WizardDialogComponent } from "./wizard-dialog.component";
import { AbstractWizardStepComponent } from "./abstract-wizard-step.component";
import { SdpIcon } from "../../common/icon/models";

@Injectable()
export class WizardDialogService {

	constructor(
		public dialog: MatDialog,
	) { }

	public openDialog<T>(
		component: AbstractWizardStepComponent.ConstructorFunction<T>,
		icon: SdpIcon.Icon,
		isCreate: boolean,
		extraData?: T
	) {
		const data: WizardDialogComponent.Data<T> = {
			component: component,
			icon: icon,
			isCreate: isCreate,
			data: extraData!
		};
		const dialogRef = this.dialog.open(
			WizardDialogComponent,
			{
				data: data
			}
		);
		return dialogRef;
	}
}
